import lock_iconUrl from "@/assets/icons/lock-closed.svg";
import cube_iconUrl from "@/assets/icons/productDetails/cube.svg";

export const summaryInfo = [
  {
    iconUrl: cube_iconUrl,
    title: "Fast & reliaible shipping",
    text: "Our commitment to fast shipping ensures that your order reaches you promptly.",
  },
  {
    iconUrl: lock_iconUrl,
    title: "Secure checkout",
    text: "Our secure checkout process ensures that your payment details are protected.",
  },
];
